import { render, staticRenderFns } from "./LastQuotations.vue?vue&type=template&id=27e24d4a&scoped=true&"
import script from "./LastQuotations.vue?vue&type=script&lang=js&"
export * from "./LastQuotations.vue?vue&type=script&lang=js&"
import style0 from "./LastQuotations.vue?vue&type=style&index=0&id=27e24d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e24d4a",
  null
  
)

export default component.exports